import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export default function ContactInfoCard() {
  const { t } = useTranslation();

  return (
    <Card className="mb-3" id="contact-info">
      <Card.Header>
        <Card.Title className="mb-0">
          <i className="fas fa-info-circle me-2" />
          {t('contact.info_title')}
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <h6 className="fw-bold">
          <i className="fas fa-envelope me-2 text-primary" />
          {t('contact.email_label')}
        </h6>
        <p className="mb-3">
          <a href="mailto:admin@kensuke-system.com">admin@kensuke-system.com</a>
        </p>
        <p className="mb-3 small text-muted">{t('contact.form_preferred_note')}</p>

        <h6 className="fw-bold">
          <i className="fas fa-user me-2 text-primary" />
          {t('contact.owner_label')}
        </h6>
        <p className="mb-3" style={{ whiteSpace: 'pre-line' }}>
          {t('contact.owner_detail')}
        </p>

        <h6 className="fw-bold">
          <i className="fas fa-map-marker-alt me-2 text-primary" />
          {t('contact.address_label')}
        </h6>
        <p className="mb-3" style={{ whiteSpace: 'pre-line' }}>
          {t('contact.address_detail')}
        </p>

        <h6 className="fw-bold">
          <i className="fas fa-clock me-2 text-primary" />
          {t('contact.hours_label')}
        </h6>
        <p className="mb-2">{t('contact.hours_weekday')}</p>
        <p className="mb-0 small text-muted">{t('contact.response_time')}</p>
      </Card.Body>
    </Card>
  );
}
